import { GroupChildWrapper } from './group-child-wrapper.model';

export class Group {
    public name: string;
    public field: string;
    public parent: Group;
    public subGroup: Array<Group | GroupChildWrapper>;
    type = "group";

    get children() {
        return this.subGroup;
    }

    constructor(group: any = {}, parent?: Group) {
        this.name = group.name;
        this.field = group.field;
        this.parent = parent;
        this.mapChildren(group.subGroup || []);
    }

    private mapChildren(items) {
        this.subGroup = items.map(item => {
            if (item.subGroup) {
                return new Group(item, this);
            }
            return new GroupChildWrapper(item, this).item;
        });
    }
}
